// ABOUTME: Polls a submitted cancellation request and presents its current result.
// ABOUTME: Keeps polling ownership outside the presentational result component.
import React, {useEffect} from 'react'

import {useCancellationRequestPolling} from '../../hooks/useCancellationRequestPolling'

import {OrderCancellationResult} from './OrderCancellationResult'

interface OrderCancellationResultContainerProps {
  orderId: string
  requestId: string
  onViewOrderDetails: () => void
  onClose: () => void
}

export const OrderCancellationResultContainer: React.FC<OrderCancellationResultContainerProps> = ({
  orderId,
  requestId,
  onViewOrderDetails,
  onClose
}) => {
  const cancellationPollingInfo = useCancellationRequestPolling(orderId, requestId)

  useEffect(() => {
    cancellationPollingInfo.triggerPolling()
  }, [requestId, cancellationPollingInfo.triggerPolling])

  return (
    <OrderCancellationResult
      resultType={cancellationPollingInfo.result ?? 'pending'}
      isPolling={cancellationPollingInfo.isPolling}
      onViewOrderDetails={onViewOrderDetails}
      onClose={onClose}
    />
  )
}
